import { inject, Injectable } from '@angular/core';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly #platform = inject(PlatformService);

  get isLoggedIn() {
    return this.#platform.isLoggedIn;
  }

  constructor() {
    this.#platform.initialize();
  }

  login() {
    return this.#platform.login();
  }

  refresh() {
    return this.#platform.refresh();
  }

  logout() {
    this.#platform.logout();
  }
}
